import React from "react";
import Margin from "../../Margin";

/**
 * Composant SuperAdminModule sert à afficher les graphiques de la partie super admin
 * à l'aide  de primeReact et de composants custom.
 */
const SuperAdminModule = () => {
  return (
    <div className="stats_container">
      <Margin position="bottom" size="s" />
    </div>
  );
};

export default SuperAdminModule;
